import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import dayjs from 'dayjs';
import type { DataSyncStatusItem } from 'lumen/utils/constants/benchmark-insight/beni-data-sync-constant-values';

interface HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipBodySignature {
  Args: {
    item: DataSyncStatusItem;
  };
}

export default class HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipBody extends Component<HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipBodySignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedExtractDate() {
    const { extractDate } = this.args.item;

    if (!extractDate) {
      return this.intl.t('market_insight.availability.unavailable');
    }

    const extractDateFormat = 'D MMM YYYY';
    const extractDateUtc = dayjs.utc(extractDate);
    const dayDiffUtc = extractDateUtc.diff(dayjs.utc(), 'day');
    const currentTimeHotelTimezone = this.hotelAndMarketService.getLocalTime();
    const extractDateHotelTimezone = currentTimeHotelTimezone.add(
      dayDiffUtc,
      'day',
    );

    // the “extract date” in the API is w.r.t to the timezone of the hotel
    // we compare the local date of the hotel against the API extract date
    // we also need to add one day to the extract date as per BE advice
    return extractDateHotelTimezone.add(1, 'day').format(extractDateFormat);
  }

  <template>
    <tr class="tooltip-table data-sync-status__tooltip__table__row">
      <td class="data-sync-status__tooltip__table__row__cell">
        <div class="data-sync-status__tooltip__table__row__cell__identifier">
          <span
            class="identifier-bullet
              {{if @item.isSynced '' 'identifier-bullet--invalid'}}"
            data-test-id={{if
              @item.isSynced
              "data-sync-status-identifier-in-sync"
              "data-sync-status-identifier-out-of-sync"
            }}
          ></span>
        </div>
      </td>
      <td class="data-sync-status__tooltip__table__row__cell">
        <span class="data-sync-status__tooltip__table__row__cell__name">
          {{@item.name}}</span>
      </td>
      <td class="data-sync-status__tooltip__table__row__cell date">
        <span class="data-sync-status__tooltip__table__row__cell__date">
          {{this.formattedExtractDate}}
        </span>
      </td>
    </tr>
  </template>
}
